import { render } from "./AboutTestsModal.vue?vue&type=template&id=5b2f069b&scoped=true"
import script from "./AboutTestsModal.vue?vue&type=script&lang=js"
export * from "./AboutTestsModal.vue?vue&type=script&lang=js"

import "./AboutTestsModal.vue?vue&type=style&index=0&id=5b2f069b&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2f069b"]])

export default __exports__